import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useLanguage } from './LanguageProvider';  // Updated import

function CalendarEmbed({ onLoad }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const { language } = useLanguage();  // Using useLanguage instead of useData

  // Reset loading state when language changes
  useEffect(() => {
    setIsLoading(true);
    setHasError(false);
  }, [language]);

  // Load Elfsight script and handle loading
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    
    script.onload = () => {
      // Give Elfsight time to initialize
      setTimeout(() => {
        setIsLoading(false);
        if (onLoad) onLoad();
      }, 1000);
    };
    
    script.onerror = () => {
      setIsLoading(false);
      setHasError(true);
      if (onLoad) onLoad();
    };
    
    document.body.appendChild(script);
    
    return () => {
      document.body.removeChild(script);
    };
  }, [onLoad, language]);

  // Clean up URL hash when component unmounts or hash changes
  useEffect(() => {
    const checkAndCleanHash = () => {
      if (window.location.hash.includes('calendar-18549a79') && window.location.hash.includes('-event-')) {
        // Check if popup is still open by looking for Elfsight popup elements
        setTimeout(() => {
          const popup = document.querySelector('.eapps-calendar-popup-open') || 
                       document.querySelector('[class*="elfsight"][class*="popup"]') ||
                       document.querySelector('[class*="eapps"][class*="popup"][class*="open"]');
          
          if (!popup) {
            // Popup is closed, clean the URL
            window.history.pushState(null, '', '#/');
          }
        }, 300);
      }
    };

    // Monitor for hash changes
    window.addEventListener('hashchange', checkAndCleanHash);
    
    // Also monitor for clicks that might close popups
    const handleClick = (e) => {
      if (window.location.hash.includes('-event-')) {
        setTimeout(checkAndCleanHash, 500);
      }
    };
    
    document.addEventListener('click', handleClick);
    
    return () => {
      window.removeEventListener('hashchange', checkAndCleanHash);
      document.removeEventListener('click', handleClick);
    };
  }, []);

  if (hasError) {
    return (
      <div className="calendar-wrapper">
        <div className="text-center text-danger">
          {language === 'fr' 
            ? 'Échec du chargement du calendrier. Veuillez réessayer plus tard.'
            : 'Failed to load the calendar. Please try again later.'}
        </div>
      </div>
    );
  }

  return (
    <div className="calendar-wrapper position-relative">
      {isLoading && (
        <div className="position-absolute top-50 start-50 translate-middle" style={{ zIndex: 10 }}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">
              {language === 'fr' ? 'Chargement...' : 'Loading...'}
            </span>
          </Spinner>
        </div>
      )}
      <div 
        className="elfsight-app-dba8934a-ac3d-4ba2-b88e-c35a058395ba"
        style={{
          width: '100%',
          minHeight: isLoading ? '400px' : 'auto',
          opacity: isLoading ? 0 : 1,
          transition: 'opacity 0.3s ease-in-out'
        }}
      />
    </div>
  );
}

export default CalendarEmbed;